import styled from "styled-components";

export const LoanAgreementWrapper = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 1rem;
  justify-content: center;
  align-items: center;
  width: ${(props) => (props.width ? props.width : "100%")};
  max-width: ${(props) => (props.maxWidth ? props.maxWidth : "60%")};
  #login-form {
    display: flex;
    flex-direction: column;
    // row-gap: 2rem;
    // border: 1.5px solid var(--color-tan_two);
    box-shadow: 33px 33px 66px #9f9f9f, -10px -10px 33px #ffffff;
    box-shadow: -5px -5px 9px rgb(255 255 255 / 45%),
      9px 9px 14px 8px rgb(94 104 121 / 30%);
    box-shadow: rgb(229 229 229) 1px 1px 11px, rgb(255, 255, 255) -1px -1px 17px;
    // padding: 3rem 4rem;
    padding: ${(props) =>
      props.padding ? props.padding : "1em 0rem 0rem 0rem"};
    .login-greetings {
      display: flex;
      flex-direction: column;
      row-gap: 1em;
    }
    #login-tab-btn {
      display: flex;
      flex-direction: row;
      justify-content: center;
      column-gap: 2rem;
    }
    #login-tab-content {
    }
    @media (max-width: 768px) {
      border: none;
      padding: 0rem;
    }
  }
  #login-privacy-policy-link {
    font-size: 1.6rem;
    text-align: center;
    & > a {
      color: var(--color-black);
    }
  }
  .infoCard {
    border: 1px solid #d6b06d;
    border-radius: 0.5rem;
    padding: 1rem;
  }
  .content {
    display: flex;
    align-content: center;
    align-items: center;
    color: #d6b06d;
    display: flex;
    text-align: -webkit-match-parent;
  }
  .pageTitle {
    display: flex;
    justify-content: center;
    margin-bottom: 5px;
  }
  .pageSubTitle {
    padding-left: 20px;
    padding-right: 20px;
    text-align: center;
  }
  .agreementBox {
    display: flex;
    flex-direction: column;
    background-color: #ffffff;
    margin-top: 10px;
    border: 1px solid #ebdede;
    border-radius: 10px;
  }
  .boxContent {
    display: flex;
    flex-direction: column;
    margin-left: 15px;
    margin-right: 15px;
    margin-top: 2px;
    margin-bottom: 5px;
  }
  .downloadButtonsStyle {
    display: grid;
    justify-items: center;
    font-size: 14px;
  }
  .downloadButton {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    background-color: #fffbfb;
    height: 66px;
    width: 210px;
    margin-top: 20px;
    border: 1px solid #c4a167;
    border-radius: 10px;
    align-items: center;
  }
  .download-img {
    margin-right: 25px;
    margin-left: 10px;
    height: 50px;
    width: 50px;
  }
  .message {
    color: #b78115;
    font-size: 1.5rem;
    padding: 2px 10px;
  }
  @media (max-width: 768px) {
    max-width: 100%;
    #login-form {
      box-shadow: None;
    }
    .progress-bar-container {
      margin: 0 2em;
    }
  }
  input[type="range"]::-webkit-slider-thumb {
    -webkit-appearance: none;
    background: #cb3443;
    height: 15px;
    width: 15px;
    border-radius: 50%;
  }
`;
